/* People's Peps: header search with live results.

   Any [data-pp-search-open] (the search icons in the header) opens the panel
   rendered by sections/pp-header.liquid. As the visitor types, Shopify's
   predictive search (search/suggest.json) is asked for products, articles,
   pages, collections and query suggestions, and the answer is drawn into the
   panel. Arrow keys move through the results, Enter opens the highlighted
   one, Enter with nothing highlighted runs the full search page, Escape
   closes. Without JavaScript the icons are plain links to the search page.

   Every visible string comes from data-l-* attributes, which the header
   section fills from its settings. Customizer-safe: one guard, delegated
   events, and the panel is looked up again on every use. */
(function () {
  'use strict';
  if (window.__ppSearchWired) return;
  window.__ppSearchWired = true;

  var cache = {};
  var ctrl = null;
  var timer = null;
  var lastTerm = '';
  var lastFocus = null;
  var active = -1;

  function panel() { return document.querySelector('[data-pp-search]'); }
  function q(r, s) { return r ? r.querySelector(s) : null; }
  function qa(r, s) { return r ? Array.prototype.slice.call(r.querySelectorAll(s)) : []; }
  function isOpen(r) { return !!r && r.getAttribute('data-open') === 'true'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function L(r, key, fallback) {
    var v = r.getAttribute('data-l-' + key);
    return v == null || v === '' ? fallback : v;
  }

  /* ---- formatting --------------------------------------------------- */
  function money(r, amount) {
    var n = parseFloat(amount);
    if (!isFinite(n)) return '';
    var fmt = r.getAttribute('data-money') || '${{amount}}';
    function grp(x, dec, thou, dp) {
      var p = x.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.join(dp);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return grp(n, 0, ',', '.');
        case 'amount_with_comma_separator': return grp(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grp(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return grp(n, 2, "'", '.');
        default: return grp(n, 2, ',', '.');
      }
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function day(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return d.toDateString(); }
  }
  /* Baymard: in a query suggestion, stress the part the visitor has not typed. */
  function suggestion(text, term) {
    var t = String(text || '');
    var i = t.toLowerCase().indexOf(term.toLowerCase());
    if (i === 0 && term.length < t.length) {
      return esc(t.slice(0, term.length)) + '<b>' + esc(t.slice(term.length)) + '</b>';
    }
    return '<b>' + esc(t) + '</b>';
  }

  /* ---- fetching ----------------------------------------------------- */
  function endpoint(r, term) {
    var base = r.getAttribute('data-url') || '/search/suggest';
    var p = [
      'q=' + encodeURIComponent(term),
      'resources[type]=' + encodeURIComponent('product,article,page,collection,query'),
      'resources[limit]=4',
      'resources[limit_scope]=each',
      'resources[options][unavailable_products]=last',
      'resources[options][fields]=' + encodeURIComponent('title,product_type,variants.title,vendor,tag,body')
    ];
    return base + '.json?' + p.join('&');
  }

  function run(r, term) {
    term = term.trim();
    lastTerm = term;
    var idle = q(r, '[data-pp-search-idle]');
    var clear = q(r, '[data-pp-search-clear]');
    if (clear) clear.hidden = term === '';
    if (term.length < 2) {
      if (ctrl) { ctrl.abort(); ctrl = null; }
      r.removeAttribute('data-loading');
      if (idle) idle.hidden = false;
      paint(r, '', null);
      return;
    }
    if (idle) idle.hidden = true;
    if (cache[term]) { paint(r, term, cache[term]); return; }
    if (ctrl) ctrl.abort();
    ctrl = 'AbortController' in window ? new AbortController() : null;
    r.setAttribute('data-loading', 'true');
    fetch(endpoint(r, term), { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) {
        cache[term] = data;
        if (term === lastTerm) { r.removeAttribute('data-loading'); paint(r, term, data); }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        r.removeAttribute('data-loading');
        if (term === lastTerm) paint(r, term, { failed: true });
      });
  }

  /* ---- drawing ------------------------------------------------------ */
  function paint(r, term, data) {
    var box = q(r, '[data-pp-search-results]');
    var foot = q(r, '[data-pp-search-foot]');
    var status = q(r, '[data-pp-search-status]');
    var input = q(r, '[data-pp-search-input]');
    active = -1;
    if (input) input.removeAttribute('aria-activedescendant');
    if (!box) return;
    if (!term || !data) {
      box.innerHTML = '';
      if (foot) foot.innerHTML = '';
      if (status) status.textContent = '';
      if (input) input.setAttribute('aria-expanded', 'false');
      return;
    }

    var searchUrl = r.getAttribute('data-search-url') || '/search';
    var allHref = searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    var viewAll = '<a class="pp-srchpop__all" href="' + esc(allHref) + '"><span>' + esc(L(r, 'view-all', 'View all results for')) +
      ' <q>' + esc(term) + '</q></span><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 8h10M9 4l4 4-4 4"/></svg></a>';

    var res = (data.resources && data.resources.results) || {};
    var queries = (res.queries || []).slice(0, 4);
    var prods = (res.products || []).slice(0, 4);
    var arts = (res.articles || []).slice(0, 3);
    var pages = (res.pages || []).slice(0, 3);
    var cols = (res.collections || []).slice(0, 3);
    var total = queries.length + prods.length + arts.length + pages.length + cols.length;
    var n = 0;

    function opt(href, inner, cls) {
      n += 1;
      return '<a class="pp-srchpop__opt' + (cls ? ' ' + cls : '') + '" role="option" aria-selected="false" tabindex="-1" id="pp-sopt-' + n + '" href="' + esc(href) + '">' + inner + '</a>';
    }
    function group(key, label, html) {
      return '<div class="pp-srchpop__group pp-srchpop__group--' + key + '" role="group" aria-labelledby="pp-sgh-' + key + '">' +
        '<p class="pp-srchpop__gh" id="pp-sgh-' + key + '" role="presentation">' + esc(label) + '</p>' + html + '</div>';
    }
    function thumb(url, cls) {
      return url ? '<img class="pp-srchpop__thumb' + (cls ? ' ' + cls : '') + '" src="' + esc(sized(url, 160)) + '" alt="" loading="lazy" width="56" height="56">'
                 : '<span class="pp-srchpop__thumb pp-srchpop__thumb--blank' + (cls ? ' ' + cls : '') + '" aria-hidden="true"></span>';
    }

    if (data.failed || total === 0) {
      box.innerHTML = '';
      box.setAttribute('data-empty', 'true');
      if (foot) {
        foot.innerHTML = '<div class="pp-srchpop__none"><p class="pp-srchpop__nonet">' + esc(L(r, 'none', 'No matches for')) + ' <q>' + esc(term) + '</q></p>' +
          '<p class="pp-srchpop__noneh">' + esc(L(r, 'hint', '')) + '</p></div>' + viewAll;
      }
      if (status) status.textContent = L(r, 'none', 'No matches for') + ' ' + term;
      if (input) input.setAttribute('aria-expanded', 'false');
      return;
    }
    box.removeAttribute('data-empty');

    var left = '';
    var right = '';
    if (queries.length) {
      left += group('queries', L(r, 'suggestions', 'Suggestions'), queries.map(function (s) {
        return opt(s.url, '<span class="pp-srchpop__qico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="10.8" cy="10.8" r="6.6"/><path d="m15.6 15.6 4 4"/></svg></span><span class="pp-srchpop__q">' + suggestion(s.text, term) + '</span>', 'pp-srchpop__opt--q');
      }).join(''));
    }
    if (cols.length) {
      left += group('collections', L(r, 'collections', 'Collections'), cols.map(function (c) {
        return opt(c.url, '<span class="pp-srchpop__t">' + esc(c.title) + '</span>', 'pp-srchpop__opt--link');
      }).join(''));
    }
    if (pages.length) {
      left += group('pages', L(r, 'pages', 'Pages'), pages.map(function (p) {
        return opt(p.url, '<span class="pp-srchpop__t">' + esc(p.title) + '</span>', 'pp-srchpop__opt--link');
      }).join(''));
    }
    if (prods.length) {
      right += group('products', L(r, 'products', 'Products'), prods.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var price = money(r, p.price);
        return opt(p.url, thumb(img) + '<span class="pp-srchpop__txt"><span class="pp-srchpop__t">' + esc(p.title) + '</span>' +
          (price ? '<span class="pp-srchpop__s">' + esc(price) + '</span>' : '') + '</span>', 'pp-srchpop__opt--rich');
      }).join(''));
    }
    if (arts.length) {
      right += group('articles', L(r, 'articles', 'Articles'), arts.map(function (a) {
        var img = a.featured_image && a.featured_image.url ? a.featured_image.url : a.image;
        return opt(a.url, thumb(img, 'pp-srchpop__thumb--wide') + '<span class="pp-srchpop__txt"><span class="pp-srchpop__t">' + esc(a.title) + '</span>' +
          '<span class="pp-srchpop__s">' + esc(day(a.published_at)) + '</span></span>', 'pp-srchpop__opt--rich');
      }).join(''));
    }

    box.innerHTML = '<div class="pp-srchpop__cols' + (left && right ? '' : ' pp-srchpop__cols--one') + '">' +
      (right ? '<div class="pp-srchpop__col pp-srchpop__col--main">' + right + '</div>' : '') +
      (left ? '<div class="pp-srchpop__col pp-srchpop__col--side">' + left + '</div>' : '') + '</div>';
    if (foot) foot.innerHTML = viewAll;
    var count = prods.length + arts.length + pages.length + cols.length;
    if (status) status.textContent = count + ' ' + (count === 1 ? L(r, 'count-one', 'result') : L(r, 'count-many', 'results'));
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  /* ---- keyboard ----------------------------------------------------- */
  function options(r) { return qa(r, '[data-pp-search-results] [role="option"]'); }
  function highlight(r, i) {
    var list = options(r);
    var input = q(r, '[data-pp-search-input]');
    if (!list.length) { active = -1; return; }
    if (i < 0) i = list.length - 1;
    if (i >= list.length) i = 0;
    list.forEach(function (o, k) { o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    active = i;
    if (input) input.setAttribute('aria-activedescendant', list[i].id);
    if (list[i].scrollIntoView) list[i].scrollIntoView({ block: 'nearest' });
  }

  /* ---- open and close ----------------------------------------------- */
  function open(r, trigger) {
    if (!r) return;
    lastFocus = trigger || document.activeElement;
    r.setAttribute('data-open', 'true');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pp-srch-open');
    qa(document, '[data-pp-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var input = q(r, '[data-pp-search-input]');
    window.setTimeout(function () {
      if (!input) return;
      input.focus();
      if (input.value) { input.select(); run(r, input.value); }
    }, 40);
  }
  function close(r) {
    if (!r || !isOpen(r)) return;
    r.setAttribute('data-open', 'false');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pp-srch-open');
    qa(document, '[data-pp-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* ignore */ } }
  }

  /* ---- events ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-pp-search-open]');
    if (opener) {
      var r = panel();
      if (!r) return;                       /* no panel: let the link go to the search page */
      e.preventDefault();
      open(r, opener);
      return;
    }
    var r2 = panel();
    if (!r2 || !isOpen(r2)) return;
    if (t.closest('[data-pp-search-close]')) { e.preventDefault(); close(r2); return; }
    var clear = t.closest('[data-pp-search-clear]');
    if (clear) {
      e.preventDefault();
      var input = q(r2, '[data-pp-search-input]');
      if (input) { input.value = ''; input.focus(); }
      run(r2, '');
      return;
    }
    var chip = t.closest('[data-pp-search-term]');
    if (chip) {
      e.preventDefault();
      var inp = q(r2, '[data-pp-search-input]');
      if (inp) { inp.value = chip.getAttribute('data-pp-search-term'); inp.focus(); }
      run(r2, chip.getAttribute('data-pp-search-term') || '');
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-pp-search-input')) return;
    var r = t.closest('[data-pp-search]');
    if (!r) return;
    window.clearTimeout(timer);
    var v = t.value;
    timer = window.setTimeout(function () { run(r, v); }, 170);
  });

  document.addEventListener('keydown', function (e) {
    var r = panel();
    if (!r || !isOpen(r)) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(r); return; }
    var input = q(r, '[data-pp-search-input]');
    if (e.target === input) {
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(r, active + 1); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); highlight(r, active - 1); return; }
      if (e.key === 'Enter' && active > -1) {
        var list = options(r);
        if (list[active]) { e.preventDefault(); window.location.href = list[active].href; }
        return;
      }
    }
    if (e.key === 'Tab') {                  /* keep focus inside the open panel */
      var sheet = q(r, '[role="dialog"]');
      var focusables = qa(sheet, 'a[href], button:not([disabled]), input:not([type="hidden"])').filter(function (el) {
        return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1';
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !f.hasAttribute('data-pp-search-form')) return;
    var input = f.querySelector('[data-pp-search-input]');
    if (input && !input.value.trim()) { e.preventDefault(); input.focus(); }
  });

  /* Back button from a result: never come back to an open panel. */
  window.addEventListener('pageshow', function () {
    var r = panel();
    if (r && isOpen(r)) close(r);
    document.documentElement.classList.remove('pp-srch-open');
  });
  document.addEventListener('shopify:section:load', function () {
    document.documentElement.classList.remove('pp-srch-open');
    cache = {};
  });
})();
